import { Controller } from "@hotwired/stimulus"

// Mobile sticky buy bar for the Cosy Fantasy landing: slides in once the hero section
// is scrolled past. Same pattern as astro_lp_sticky, but target-based instead of a
// hard-coded hero selector. The bar only exists visually on mobile (CSS). Classic JS.
export default class extends Controller {
  static targets = ["hero", "bar"]

  connect() {
    if (!this.hasHeroTarget || !this.hasBarTarget) return
    this.lastVisible = false
    this.onScroll = () => this.check()
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.check()
  }

  disconnect() {
    if (this.onScroll) window.removeEventListener("scroll", this.onScroll)
  }

  check() {
    const shouldShow = this.heroTarget.getBoundingClientRect().bottom < 0
    if (shouldShow !== this.lastVisible) {
      this.barTarget.classList.toggle("is-visible", shouldShow)
      this.lastVisible = shouldShow
    }
  }
}
